<template>
    <div class="selected-option">
        <span>{{ item.name }}</span>
    </div>
</template>

<script>

export default {
	props: {
		item: Object,
	},
};
</script>

<style lang="scss" scoped>
.selected-option {
	display: inline-flex;
	align-items: center;
	margin-right: 8px;
	padding: 4px 8px;
	background-color: #e0e0e0;
	border: 1px solid success;
	border-radius: 2px;
}

.selected-option span {
  	margin-right: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/selected-option.vue